import { render, staticRenderFns } from "./clicks-per-day.vue?vue&type=template&id=5c5ab1a0"
import script from "./clicks-per-day.vue?vue&type=script&lang=js"
export * from "./clicks-per-day.vue?vue&type=script&lang=js"
import style0 from "./clicks-per-day.vue?vue&type=style&index=0&id=5c5ab1a0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports